import { GeneralToggle } from "../../../../general";

const perPageOptions = [10, 25, 50, 100, 250];

const PerPageSwitcher = ({ perPage, setPerPage, minWidth = 100, fixedMinWidth = false  }) => {    
    return (
        <GeneralToggle 
            label='Limit' 
            value={perPage} 
            setValue={setPerPage}
            items={perPageOptions}
            minWidth={minWidth}
            fixedMinWidth={fixedMinWidth}
        />
    );
}

export default PerPageSwitcher;